import axios from 'axios';
import { IAuthDto, IAuthModelCodeParams, IAuthModelPayload, IAuthModelUrl } from 'entities/Auth/Auth.models';
import { getAuthRedirectUri } from 'entities/Auth/Auth.helper';

const basePath = 'auth';

export const authTransport = {
  addAuthModel: (payload: IAuthModelPayload): Promise<IAuthDto> => {
    const params: IAuthModelPayload = { ...payload, redirectUri: getAuthRedirectUri() };
    return axios.get(`${basePath}/callback`, { params });
  },
  refreshToken: (refreshToken: string): Promise<IAuthDto> => axios.put(`${basePath}`, { refreshToken }),
  deleteAuthModel: (): Promise<void> => axios.delete(`${basePath}`),
  getAuthModelCode: (): Promise<IAuthModelUrl> => {
    const params: IAuthModelCodeParams = { redirectUri: getAuthRedirectUri() };
    return axios.get(`${basePath}/code`, { params });
  },
};
